import { render, staticRenderFns } from "./ProductHover.vue?vue&type=template&id=9ca655c0&scoped=true"
import script from "./ProductHover.vue?vue&type=script&lang=js"
export * from "./ProductHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca655c0",
  null
  
)

export default component.exports